export default {
  en: {
    title: "Let's check your {{nom}}",
    subtitle: 'No multiple-choice tests — we’ll just talk for a couple of minutes.',
    exampleResult: 'Example result',
    pronunciation: 'Pronunciation',
    vocabulary: 'Vocabulary',
    grammar: 'Grammar',
    fluency: 'Fluency',
    fillerWords: 'Filler words',
  },
  ru: {
    title: 'Проверим твой {{nom}}',
    subtitle: 'Никаких тестов с вариантами — просто поговорим пару минут.',
    exampleResult: 'Пример результата',
    pronunciation: 'Произношение',
    vocabulary: 'Словарный запас',
    grammar: 'Грамматика',
    fluency: 'Беглость речи',
    fillerWords: 'Слова-паразиты',
  },
  de: {
    title: 'Prüfen wir dein {{nom}}',
    subtitle: 'Keine Multiple-Choice-Tests — wir unterhalten uns einfach ein paar Minuten.',
    exampleResult: 'Beispielergebnis',
    pronunciation: 'Aussprache',
    vocabulary: 'Wortschatz',
    grammar: 'Grammatik',
    fluency: 'Sprechflüssigkeit',
    fillerWords: 'Füllwörter',
  },
  pt: {
    title: 'Vamos avaliar seu {{nom}}',
    subtitle: 'Nada de testes de múltipla escolha — só uma conversa de alguns minutos.',
    exampleResult: 'Exemplo de resultado',
    pronunciation: 'Pronúncia',
    vocabulary: 'Vocabulário',
    grammar: 'Gramática',
    fluency: 'Fluência',
    fillerWords: 'Palavras de preenchimento',
  },
  fr: {
    title: 'Vérifions ton {{nom}}',
    subtitle: 'Pas de QCM — on discute simplement quelques minutes.',
    exampleResult: 'Exemple de résultat',
    pronunciation: 'Prononciation',
    vocabulary: 'Vocabulaire',
    grammar: 'Grammaire',
    fluency: 'Fluidité',
    fillerWords: 'Mots de remplissage',
  },
  es: {
    title: 'Vamos a evaluar tu {{nom}}',
    subtitle: 'Nada de tests de opción múltiple — solo charlamos un par de minutos.',
    exampleResult: 'Ejemplo de resultado',
    pronunciation: 'Pronunciación',
    vocabulary: 'Vocabulario',
    grammar: 'Gramática',
    fluency: 'Fluidez',
    fillerWords: 'Muletillas',
  },
};
